import React from 'react'
import styled from 'styled-components'
import {
  Alert as AlertComponent,
} from 'react-bootstrap'

const StyledAlert = styled(AlertComponent)`
  box-shadow: none;
`

const Alert: React.FC<any> = (props) => {
  return (
    <StyledAlert
      {...props}
      bsStyle={props.bsStyle || ''}
    />
  )
}

export default Alert
